window.groupex = {
	gmapLoaded: false,
	mapData: {
		fournisseurs: {},
		members: {},
	},
	calendar: {
		eventsCount: 0,
		currentEventIds: [],
	},
};

window.initMapGroupex = function () {
	window.groupex.gmapLoaded = true;
};

const appHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

if (groupex_vars.lang == "fr-FR") {
	dayjs.locale("fr");
}

init_list_filters();

events_calendar();

colorscheme_switch();

add_delete_contacts_personal();

add_delete_fournisseurs_personal();

bulk_checkboxes();

groupex_popup();

jQuery(document).ready(function () {
	jQuery(".entry-content .gallery a").fancybox();

	if (document.getElementById("lms_items")) {
		window.addEventListener("resize", function () {
			learndash_course_grid_init_grid_responsive_design();
		});

		window.addEventListener("load", function () {
			learndash_course_grid_init_grid_responsive_design();
		});

		document
			.querySelector('form[name="learndash_course_grid_filter"]')
			.addEventListener("input", (ev) => {
				document
					.querySelector(".g-grid")
					.insertAdjacentHTML(
						"beforeend",
						'<div class="loader_wrap"><span class="loader"></span></div>',
					);
				this.querySelector("button.apply").click();
			});

		document.addEventListener("click", function (e) {
			const el = e.target;

			if (
				!el.matches(
					'.learndash-course-grid[data-pagination="button"] .pagination .custom-load-more',
				)
			) {
				return;
			}

			e.preventDefault();

			const wrapper = el.closest(".learndash-course-grid");
			const filter = document.querySelector(
				'.learndash-course-grid-filter[data-course_grid_id="' +
					wrapper.id +
					'"]',
			);

			const data = {
				action: "ld_cg_load_more",
				nonce: LearnDash_Course_Grid.nonce.load_posts,
				course_grid: JSON.stringify(wrapper.dataset),
				filter: JSON.stringify(lms_prepare_filter(filter)),
			};

			document
				.querySelector(".g-grid")
				.insertAdjacentHTML(
					"beforeend",
					'<div class="loader_wrap"><span class="loader"></span></div>',
				);

			// AJAX request
			fetch(
				LearnDash_Course_Grid.ajaxurl + "?" + new URLSearchParams(data),
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					if (typeof data !== "undefined") {
						if (data.status == "success") {
							const items_wrapper =
								wrapper.querySelector(".items-wrapper");
							document.querySelector(".loader_wrap").remove();

							items_wrapper.insertAdjacentHTML(
								"beforeend",
								data.html,
							);

							if (data.page !== "complete") {
								wrapper.dataset.page = data.page;
							}

							if (data.page == "complete") {
								const pagination =
									wrapper.querySelector(".pagination");

								if (pagination) {
									pagination.remove();
								}
							}
						}
					}
				})
				.catch((error) => {
					console.log(error);
				});
		});
	}

	if (jQuery("body").hasClass("single-fournisseur")) {
		jQuery("#main-nav .is_fournisseur").addClass("current_page_ancestor");
	}

	if (document.getElementById("autoLoadMembersMap")) {
		trigger_list_filters();
	}

	facture_calculator();

	let $ancestor_open = jQuery(
		"#main-nav .current_page_ancestor.menu-item-has-children",
	);
	if ($ancestor_open.length) {
		setTimeout(function () {
			jQuery("#main-nav").foundation(
				"down",
				$ancestor_open.find(".submenu"),
			);
		}, 150);
	}

	jQuery("#printpage").on("click", function (event) {
		event.preventDefault();
		jQuery("body").addClass("print");
		window.print();
		jQuery("body").removeClass("print");
	});

	[...document.querySelectorAll(".glide-blog")].forEach((el, i) => {
		new Glide(el, {
			type: "slider",
			hoverpause: false,
			keyboard: false,
			perView: 1,
			gap: 20,
		}).mount();
	});

	[...document.querySelectorAll(".glide-module-textgallery")].forEach(
		(el, i) => {
			new Glide(el, {
				type: "slider",
				hoverpause: false,
				keyboard: false,
				perView: 1,
				gap: 20,
			}).mount();
		},
	);

	fournisseur_row_links();

	const filterDate = document.getElementById("dateFilter");
	if (filterDate) {
		let flatpickrOptions = {
			mode: "range",
			disableMobile: true,
			showMonths: 1,
			dateFormat: "d M Y",
			onClose: function (selectedDates, dateStr, instance) {
				if (selectedDates.length > 1) {
					let dateStart = instance.formatDate(selectedDates[0], "U");
					let dateEnd = instance.formatDate(selectedDates[1], "U");
					jQuery("#dateRange").val(dateStart + "-" + dateEnd);
					trigger_list_filters(true);
				}
			},
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates.length > 1) {
					let dateYStart = instance.formatDate(selectedDates[0], "Y");
					let dateYEnd = instance.formatDate(selectedDates[1], "Y");

					if (dateYStart == dateYEnd) {
						filterDate.value =
							instance.formatDate(selectedDates[0], "d M") +
							instance.l10n.rangeSeparator +
							instance.formatDate(
								selectedDates[1],
								instance.config.dateFormat,
							);
					}
				}
			},
		};

		if (filterDate.dataset.archive) {
			flatpickrOptions.minDate = new Date(
				filterDate.dataset.archive,
				0,
				1,
			);
			flatpickrOptions.maxDate = new Date(
				filterDate.dataset.archive,
				11,
				31,
			);
			flatpickrOptions.enable = [
				{
					from: new Date(filterDate.dataset.archive, 0, 1),
					to: new Date(filterDate.dataset.archive, 11, 31),
				},
			];
		}
		if (groupex_vars.lang == "fr-FR") {
			flatpickrOptions.locale = "fr";
		}
		flatpickr(filterDate, flatpickrOptions);
	}

	const filtersSelect = document.querySelectorAll("select.select");
	if (filtersSelect) {
		[...filtersSelect].forEach((el, i) => {
			new SlimSelect({
				select: el,
				settings: {
					placeholderText: el.dataset.placeholder,
					searchText: groupex_vars.i18n.select.searchText,
					searchPlaceholder:
						groupex_vars.i18n.select.searchPlaceholder,
					allowDeselect: true,
				},
				events: {
					afterChange: (newVal) => {
						trigger_list_filters(true);
					},
				},
			});
		});
	}

	const customSelects = document.querySelectorAll("select.custom_select");
	if (customSelects) {
		[...customSelects].forEach((el, i) => {
			new SlimSelect({
				select: el,
				settings: {
					placeholderText: el.dataset.placeholder,
					searchText: groupex_vars.i18n.select.searchText,
					searchPlaceholder:
						groupex_vars.i18n.select.searchPlaceholder,
					allowDeselect: true,
				},
			});
		});
	}

	[...document.querySelectorAll('input[type="radio"].view')].forEach(
		(element, i) => {
			element.addEventListener("change", function (el) {
				trigger_list_filters();
			});
		},
	);

	[
		...document.querySelectorAll(
			'iframe[src*="youtube.com"], iframe[src*="vimeo.com"], .entry-content iframe',
		),
	].forEach((element, i) => {
		let innerWidth = Math.max(
				element.scrollWidth,
				element.offsetWidth,
				element.clientWidth,
			),
			innerHeight = Math.max(
				element.scrollHeight,
				element.offsetHeight,
				element.clientHeight,
			);
		if (innerWidth / innerHeight > 1.5) {
			wrap(element, "div", ["widescreen", "responsive-embed"]);
		} else {
			wrap(element, "div", "responsive-embed");
		}
	});

	video_module_fns();

	like_buttons_click();

	jQuery(".contact-map").each(function () {
		var map = initMapWithMarkers(jQuery(this));
	});

	run_password_meter();
});

const passwordField = document.querySelector(".password_wrap input");
if (passwordField) {
	const PASSWORD = "password";
	const TEXT = "text";

	const passwordIcon = document.querySelector(".password_wrap .preview_icon");
	const eyeIcon = document.querySelector(".fas");

	eyeIcon.classList.add("fa-eye");

	function togglePassword(e) {
		e.preventDefault();
		if (passwordField.type === PASSWORD) {
			passwordField.type = TEXT;

			eyeIcon.classList.remove("fa-eye");
			eyeIcon.classList.add("fa-eye-slash");
		} else {
			passwordField.type = PASSWORD;

			eyeIcon.classList.add("fa-eye");
			eyeIcon.classList.remove("fa-eye-slash");
		}
	}

	passwordIcon.addEventListener("click", togglePassword);
}

function trigger_pagination(paginationWrap) {
	let pagination = paginationWrap.querySelector(".custom-pagination");
	if (pagination) {
		[...pagination.querySelectorAll("a")].forEach((el) => {
			el.addEventListener("click", function (ev) {
				ev.preventDefault();
				let disabledClasses = ["active", "disabled"];
				if (
					!disabledClasses.some((className) =>
						ev.currentTarget.classList.contains(className),
					)
				) {
					let goToPage = ev.currentTarget.dataset.page,
						formFilters = document.getElementById("formFilters");

					formFilters.querySelector('input[name="page"]').value =
						goToPage;

					if (goToPage == 1) {
						document
							.querySelector("body")
							.classList.remove("filters-greater-than-1");
					} else {
						document
							.querySelector("body")
							.classList.add("filters-greater-than-1");
					}

					trigger_list_filters(false);

					formFilters.scrollIntoView({
						behavior: "smooth",
					});
				}
			});
		});
	}
}

function add_delete_contacts_personal() {
	[
		...document.querySelectorAll(
			"a.add_contact:not(.inited), a.remove_contact:not(.inited)",
		),
	].forEach((el) => {
		let boundClickAddRemove = add_delete_contacts_personal_click.bind(
			null,
			el,
		);
		el.removeEventListener("click", boundClickAddRemove);
		el.addEventListener("click", boundClickAddRemove, false);
		el.classList.add("inited");
	});
}

async function add_delete_contacts_personal_click(el, ev) {
	ev.preventDefault();
	let url = groupex_vars.api.addcontact,
		$parent = ev.currentTarget.parentElement,
		slug = ev.currentTarget.dataset.slug,
		isDelete = false;
	if (ev.currentTarget.classList.contains("remove_contact")) {
		url = groupex_vars.api.deletecontact;
		isDelete = true;
	}

	$parent.classList.add("loading");

	let response = await fetch(url, {
		method: "POST",
		body: JSON.stringify({ slug: slug }),
		headers: {
			"Content-type": "application/json; charset=UTF-8",
		},
	});

	let result = await response.json();

	$parent.classList.remove("loading");

	if (isDelete && document.querySelector(".module-members-p")) {
		let deletedItem = document.querySelector(
			'.member[data-slug="' + slug + '"]',
		);
		if (deletedItem) {
			deletedItem.remove();
		}
		if (document.querySelectorAll(".member").length == 0) {
			document.querySelector(".no-contacts-p").style.display = "block";
		}
	} else {
		$parent.innerHTML = result.html;
		add_delete_contacts_personal();
	}
}

function add_delete_fournisseurs_personal() {
	[
		...document.querySelectorAll(
			"a.add_favorite:not(.inited), a.remove_favorite:not(.inited)",
		),
	].forEach((el) => {
		let boundClickAddRemoveF = add_delete_fournisseurs_personal_click.bind(
			null,
			el,
		);
		el.removeEventListener("click", boundClickAddRemoveF);
		el.addEventListener("click", boundClickAddRemoveF, false);
		el.classList.add("inited");
	});
}

async function add_delete_fournisseurs_personal_click(el, ev) {
	ev.preventDefault();
	let url = groupex_vars.api.addfavorite,
		$parent = ev.currentTarget.parentElement,
		slug = ev.currentTarget.dataset.slug,
		type = ev.currentTarget.dataset.type,
		isDelete = false;
	if (ev.currentTarget.classList.contains("remove_favorite")) {
		url = groupex_vars.api.deletefavorite;
		isDelete = true;
	}

	$parent.classList.add("loading");

	let response = await fetch(url, {
		method: "POST",
		body: JSON.stringify({ slug: slug, type: type }),
		headers: {
			"Content-type": "application/json; charset=UTF-8",
		},
	});

	let result = await response.json();

	$parent.classList.remove("loading");

	if (isDelete && document.querySelector(".module-members-p")) {
		/*let deletedItem = document.querySelector(
			'.member[data-slug="' + slug + '"]',
		);
		if (deletedItem) {
			deletedItem.remove();
		}
		if (document.querySelectorAll(".member").length == 0) {
			document.querySelector(".no-contacts-p").style.display = "block";
		}*/
	} else {
		$parent.innerHTML = result.html;
		add_delete_fournisseurs_personal();
	}
}

function bulk_checkboxes() {
	[...document.querySelectorAll(".col-bulk input")].forEach((el) => {
		let boundChangeEvent = bulk_checkboxes_change.bind(null, el);
		el.removeEventListener("change", boundChangeEvent);
		el.addEventListener("change", boundChangeEvent, false);
	});
	[...document.querySelectorAll("th.col-bulk .print")].forEach((el) => {
		let boundClickEvent = bulk_checkboxes_print.bind(null, el);
		el.removeEventListener("click", boundClickEvent);
		el.addEventListener("click", boundClickEvent, false);
	});
}

async function bulk_checkboxes_print(el, ev) {
	let table = el.closest("table"),
		checkboxes = table.querySelectorAll("td.col-bulk input:checked"),
		url = groupex_vars.api.pdfs,
		filenames = [];
	[...checkboxes].forEach((input) => {
		filenames.push(input.value);
	});

	table.classList.add("loading");
	table.parentElement.classList.add("loading");
	table.parentElement.classList.add("is_bulk");

	let response = await fetch(url, {
		method: "POST",
		body: JSON.stringify({ filenames: filenames }),
		headers: {
			"Content-type": "application/json; charset=UTF-8",
		},
	});

	let result = await response.json();

	window.open(result);

	table.classList.remove("loading");
	table.parentElement.classList.remove("loading");
	table.parentElement.classList.remove("is_bulk");
}

function bulk_checkboxes_change(el, ev) {
	let hasOneChecked = false,
		table = el.closest("table"),
		printBtn = table.querySelector("th.col-bulk .print");

	if (el.name == "all") {
		let checkboxes = table.querySelectorAll("td.col-bulk input");
		[...checkboxes].forEach((input) => {
			if (el.checked) {
				hasOneChecked = true;
				input.checked = true;
			} else {
				input.checked = false;
			}
		});
	} else {
		let checkboxes = table.querySelectorAll("td.col-bulk input");

		[...checkboxes].forEach((input) => {
			if (input.checked) {
				hasOneChecked = true;
			}
		});
	}

	// Show/hide print btn
	if (printBtn) {
		if (hasOneChecked) {
			table.classList.add("bulk_selected");
			printBtn.style.display = "block";
		} else {
			table.classList.remove("bulk_selected");
			printBtn.style.display = "none";
		}
	}
}

function init_list_filters() {
	let formFilters = document.getElementById("formFilters");
	if (formFilters) {
		let type = formFilters.querySelector('input[name="type"]').value,
			paginationWrap = document.querySelector(
				'[data-paginationWrapType="' + type + '"]',
			);

		// Pagination logic
		if (paginationWrap) {
			trigger_pagination(paginationWrap);
		}

		// Filters submit
		formFilters.onsubmit = async (e) => {
			e.preventDefault();

			let formData = new FormData(formFilters),
				viewFilter = formData.get("view");

			let dataContentWrapper = document.querySelector(
				"div[data-" + formData.get("type") + "]",
			);

			if (dataContentWrapper) {
				dataContentWrapper.classList.add("loading");
				if (viewFilter) {
					if (viewFilter == "map") {
						dataContentWrapper.parentElement.parentElement.classList.remove(
							"is-list",
							"is-favorites",
						);
						dataContentWrapper.parentElement.parentElement.classList.add(
							"is-map",
						);
					} else {
						dataContentWrapper.parentElement.parentElement.classList.remove(
							"is-map",
							"is-favorites",
						);
						dataContentWrapper.parentElement.parentElement.classList.add(
							"is-list",
						);
						if (viewFilter == "favorites") {
							dataContentWrapper.parentElement.parentElement.classList.add(
								"is-favorites",
							);
						}
					}
				} else {
					dataContentWrapper.parentElement.parentElement.classList.remove(
						"is-map",
						"is-favorites",
					);
				}
			}

			if (formData.get("type") == "post") {
				// used to hide the big post

				document
					.querySelector("body")
					.classList.add("has-post-filters-loading");
			}

			let response = await fetch(groupex_vars.api.filters, {
				method: "POST",
				body: JSON.stringify(serialize(formData)),
				headers: {
					"Content-type": "application/json; charset=UTF-8",
					"X-WP-Nonce": groupex_vars.nonce,
				},
			});

			let result = await response.json();

			if (formData.get("type") == "post") {
				// used to hide the big post
				if (formData.get("taxonomy[category]") == null) {
					document
						.querySelector("body")
						.classList.remove("has-post-filters");
				} else {
					document
						.querySelector("body")
						.classList.add("has-post-filters");
				}

				document
					.querySelector("body")
					.classList.remove("has-post-filters-loading");
			}

			if (dataContentWrapper) {
				if (formData.get("type") == "invoices_custom") {
					[
						...document.querySelectorAll(".list-invoices_custom"),
					].forEach((invoices_custom) => {
						invoices_custom.remove();
					});
					document
						.querySelector(".module-filters")
						.insertAdjacentHTML("afterend", result.html);
				} else {
					dataContentWrapper.innerHTML = result.total_pages
						? result.html
						: result.nodata;
				}

				dataContentWrapper.classList.remove("loading");
			}

			if (paginationWrap) {
				paginationWrap.innerHTML = result.pagination;
				trigger_pagination(paginationWrap);
			}

			if (type == "fournisseur") {
				if (viewFilter == "map") {
					initFournisseursMap(
						result.geoJson != "" ? result.geoJson : "",
					);
				} else {
					fournisseur_row_links();
					add_delete_fournisseurs_personal();
				}
			} else if (type == "members") {
				if (viewFilter == "map") {
					initMembersMap(result.geoJson != "" ? result.geoJson : "");
				}

				add_delete_contacts_personal();
			}

			like_buttons_click();

			bulk_checkboxes();

			return false;
		};
	}
}

function trigger_list_filters(resetPagination = false) {
	let formElem = document.getElementById("formFilters");
	if (formElem) {
		if (resetPagination) {
			document
				.querySelector("body")
				.classList.remove("filters-greater-than-1");

			formElem.querySelector('input[name="page"]').value = "1";
		}

		formElem.requestSubmit();
	}
}

function events_calendar() {
	document.addEventListener("DOMContentLoaded", function () {
		let calendarEl = document.getElementById("eventsCalendar");

		if (calendarEl) {
			let alternateItems = next(calendarEl.parentNode, ".calendar_items"),
				alternateItemList = false,
				alternateItemListSet = 0,
				noEventsDiv = false;

			if (alternateItems) {
				(alternateItemList =
					alternateItems.querySelector(".current_items")),
					(noEventsDiv = next(alternateItemList, ".no-events"));
			}

			let calendarOptions = {
				initialView: "dayGridMonth",
				timeZone: groupex_vars.timezone,
				events: {
					url: groupex_vars.api.events,
					extraParams: {
						cat: calendarEl.dataset.cat,
						getItem: calendarEl.dataset.getitem,
					},
					success: function (data) {
						window.groupex.calendar.eventsCount = data.length;
						if (data.length == 0 && noEventsDiv) {
							noEventsDiv.style.display = "block";
						}
					},
				},
				fixedWeekCount: false,
				displayEventTime: false,
				selectable: false,
				headerToolbar: false,
				contentHeight: "auto",
				firstDay: 1,
				datesSet: function (arg) {
					document.querySelectorAll(
						"#eventsControls .monthyear",
					)[0].innerHTML = arg.view.getCurrentData().viewTitle;
					if (alternateItems) {
						let alternateTitle =
							alternateItems.querySelector(".current_month");

						if (alternateTitle) {
							alternateTitle.innerHTML =
								arg.view.getCurrentData().viewTitle;
						}

						if (alternateItemList) {
							alternateItemList.innerHTML = "";
							if (noEventsDiv) {
								noEventsDiv.style.display = "none";
							}
						}
					}
					window.groupex.calendar.currentEventIds = [];
				},
				eventDidMount: function (info) {
					FullCalendar_add_classes_days_with_events(info.event);

					if (
						!window.groupex.calendar.currentEventIds.includes(
							info.event.id,
						)
					) {
						window.groupex.calendar.currentEventIds.push(
							info.event.id,
						);

						new Foundation.Tooltip(jQuery(info.el), {
							tipText: info.event.title,
						});

						if (alternateItemList) {
							if (
								info.event.start.getMonth() + 1 ==
								info.view
									.getCurrentData()
									.viewApi.currentEnd.getUTCMonth()
							) {
								if (info.event.extendedProps.item) {
									alternateItemList.insertAdjacentHTML(
										"beforeend",
										info.event.extendedProps.item,
									);
								}
							} else {
								window.groupex.calendar.eventsCount -= 1; // remove count
							}

							if (window.groupex.calendar.eventsCount == 0) {
								noEventsDiv.style.display = "block";
							}
						}
					}
				},
				eventClick: function (info) {
					let url = info.event.extendedProps.link;
					if (url != "") {
						window.location.href = url;
					}
				},
				loading: function (isLoading) {
					if (window.calendar) {
						if (isLoading) {
							window.calendar.el.classList.add("loading");
						} else {
							window.calendar.el.classList.remove("loading");
						}
					}
				},
			};

			if (groupex_vars.lang == "fr-FR") {
				calendarOptions.locale = "fr";
			}

			window.calendar = new FullCalendar.Calendar(
				calendarEl,
				calendarOptions,
			);

			calendar.render();

			window.calendar.el.classList.add("loading");

			document
				.getElementById("eventMonthNext")
				.addEventListener("click", function () {
					calendar.next();
				});
			document
				.getElementById("eventMonthPrev")
				.addEventListener("click", function () {
					calendar.prev();
				});

			let eventSliderEl = document.getElementById("glide-events");
			if (eventSliderEl) {
				let eventSlider = new Glide(eventSliderEl, {
					type: "slider",
					hoverpause: false,
					keyboard: false,
					perView: 1,
					gap: 20,
					dragDistance: false,
					touchDistance: false,
				}).mount();

				eventSlider.on("run", (direction) => {
					let currentItemIndex = eventSlider.index;
					[
						...document.querySelectorAll("#glide-events .date"),
					].forEach((el, i) => {
						el.classList.remove("active");

						if (i == currentItemIndex) {
							el.classList.add("active");
							calendar.gotoDate(el.dataset.start);
						}
					});
				});
			}
		}
	});
}

function FullCalendar_add_classes_days_with_events(event) {
	let dateStart = event.startStr,
		dateEnd = event.endStr,
		dateRanged = enumerateDaysBetweenDates(dateStart, dateEnd);

	dateRanged.forEach(function (date, index) {
		let day = window.calendar.el.querySelector(
			'.fc-day[data-date="' + date + '"]',
		);

		if (day) {
			day.classList.add("has_event");
			if (event.extendedProps.sameDay == "no") {
				day.classList.add("event-not-sameday");
			}
		}
	});
}

const enumerateDaysBetweenDates = function (startDate, endDate) {
	let dates = [];

	let currDate = dayjs(startDate),
		lastDate = dayjs(endDate),
		days = lastDate.diff(currDate, "days") - 1,
		i = 0;

	dates.push(currDate.format("YYYY-MM-DD"));

	while (i < days) {
		dates.push(currDate.add(i + 1, "days").format("YYYY-MM-DD"));
		i++;
	}

	return dates;
};

function fournisseur_row_links() {
	[...document.querySelectorAll(".fournisseur_row")].forEach(
		(link) =>
			(link.onclick = (ev) => {
				if (ev.srcElement.tagName.toLowerCase() !== "a") {
					window.location.href = ev.currentTarget.dataset.url;
				}
			}),
	);
}

function serialize(data) {
	let obj = {};
	for (let [key, value] of data) {
		if (obj[key] !== undefined) {
			if (!Array.isArray(obj[key])) {
				obj[key] = [obj[key]];
			}
			obj[key].push(value);
		} else {
			obj[key] = value;
		}
	}
	return obj;
}

function initFournisseursMap(GeoJsonData = "") {
	const mapFournisseurs = document.getElementById("mapFournisseurs");
	if (mapFournisseurs && window.groupex.gmapLoaded) {
		window.groupex.mapData.fournisseurs.map = new google.maps.Map(
			mapFournisseurs,
			{
				zoom: 8,
				disableDefaultUI: true,
				zoomControl: true,
				styles: getMapDarkStyle(),
				center: { lat: 45.508888, lng: -73.561668 },
			},
		);

		var bounds = new google.maps.LatLngBounds();

		window.groupex.mapData.fournisseurs.map.data.addListener(
			"addfeature",
			function (e) {
				processPoints(e.feature.getGeometry(), bounds.extend, bounds);
				window.groupex.mapData.fournisseurs.map.setCenter(
					bounds.getCenter(),
				);
				window.groupex.mapData.fournisseurs.map.fitBounds(bounds);
			},
		);

		window.groupex.mapData.fournisseurs.map.data.addGeoJson(GeoJsonData, {
			idPropertyName: "storeid",
		});

		window.groupex.mapData.fournisseurs.map.data.setStyle((feature) => {
			return {
				icon: {
					url: groupex_vars.media.mapIcon,
					scaledSize: new google.maps.Size(32, 32),
				},
			};
		});

		window.groupex.mapData.fournisseurs.infoWindow =
			new google.maps.InfoWindow();

		window.groupex.mapData.fournisseurs.infoWindow.addListener(
			"closeclick",
			() => {
				let activeFournisseurSmall = document.querySelector(
					".fournisseur-small.active",
				);
				if (activeFournisseurSmall) {
					activeFournisseurSmall.classList.remove("active");
				}
			},
		);

		window.groupex.mapData.fournisseurs.map.data.addListener(
			"click",
			(event) => {
				mapInfoWindow(event.feature);

				let storeid = event.feature.getProperty("storeid"),
					listItemById = document.querySelector(
						'.fournisseur-small[data-id="' + storeid + '"]',
					);
				if (listItemById) {
					listItemById.classList.add("active");
					let top = listItemById.getBoundingClientRect().top,
						scroller = SimpleBar.instances.get(
							document.querySelector(".map_list"),
						),
						scrollerTop = scroller
							.getScrollElement()
							.getBoundingClientRect().top;

					if (top - scrollerTop >= 0) {
						top = top - scrollerTop;
					}

					scroller.getScrollElement().scrollTop = top;
				}
			},
		);

		[...document.querySelectorAll(".fournisseur-small")].forEach((el) => {
			el.addEventListener("click", function (ev) {
				let feature =
					window.groupex.mapData.fournisseurs.map.data.getFeatureById(
						ev.currentTarget.dataset.id,
					);

				if (feature) {
					[
						...document.querySelectorAll(".fournisseur-small"),
					].forEach((searchedEl) => {
						searchedEl.classList.remove("active");
					});
					ev.currentTarget.classList.add("active");
					mapInfoWindow(feature);
				}
			});
		});
	}
}

function initMembersMap(GeoJsonData = "") {
	const mapMembers = document.getElementById("mapMembers");
	if (mapMembers && window.groupex.gmapLoaded) {
		window.groupex.mapData.members.map = new google.maps.Map(mapMembers, {
			zoom: 8,
			disableDefaultUI: true,
			zoomControl: true,
			styles: getMapDarkStyle(),
			center: { lat: 45.508888, lng: -73.561668 },
		});

		var bounds = new google.maps.LatLngBounds();

		window.groupex.mapData.members.map.data.addListener(
			"addfeature",
			function (e) {
				processPoints(e.feature.getGeometry(), bounds.extend, bounds);
				window.groupex.mapData.members.map.setCenter(
					bounds.getCenter(),
				);
				window.groupex.mapData.members.map.fitBounds(bounds);
			},
		);

		window.groupex.mapData.members.map.data.addGeoJson(GeoJsonData, {
			idPropertyName: "storeid",
		});

		window.groupex.mapData.members.map.data.setStyle((feature) => {
			return {
				icon: {
					url: groupex_vars.media.mapIcon,
					scaledSize: new google.maps.Size(32, 32),
				},
			};
		});

		window.groupex.mapData.members.infoWindow =
			new google.maps.InfoWindow();

		window.groupex.mapData.members.infoWindow.addListener(
			"closeclick",
			() => {
				let activeMemberItem = document.querySelector(
					".member-item.active",
				);
				if (activeMemberItem) {
					activeMemberItem.classList.remove("active");
				}
			},
		);

		window.groupex.mapData.members.map.data.addListener(
			"click",
			(event) => {
				mapInfoWindowMember(event.feature);

				let storeid = event.feature.getProperty("storeid"),
					listItemById = document.querySelector(
						'.member-item[data-id="' + storeid + '"]',
					);
				if (listItemById) {
					listItemById.classList.add("active");
					let top = listItemById.getBoundingClientRect().top,
						scroller = SimpleBar.instances.get(
							document.querySelector(".map_list"),
						),
						scrollerTop = scroller
							.getScrollElement()
							.getBoundingClientRect().top;

					if (top - scrollerTop >= 0) {
						top = top - scrollerTop;
					}

					scroller.getScrollElement().scrollTop = top;
				}
			},
		);

		[...document.querySelectorAll(".member-item")].forEach((el) => {
			el.addEventListener("click", function (ev) {
				if (ev.target.tagName.toLowerCase() !== "a") {
					let feature =
						window.groupex.mapData.members.map.data.getFeatureById(
							ev.currentTarget.dataset.id,
						);

					if (feature) {
						[...document.querySelectorAll(".member-item")].forEach(
							(searchedEl) => {
								searchedEl.classList.remove("active");
							},
						);
						ev.currentTarget.classList.add("active");
						mapInfoWindowMember(feature);

						if (
							Foundation.MediaQuery.current == "small" ||
							Foundation.MediaQuery.current == "medium"
						) {
							mapMembers.scrollIntoView({
								behavior: "smooth",
								block: "start",
								inline: "nearest",
							});
						}
					}
				}
			});
		});
	}
}

function mapInfoWindowMember(feature) {
	const name = feature.getProperty("name");
	const address = feature.getProperty("address");
	const phones = feature.getProperty("phones");
	const addresstitle = feature.getProperty("addresstitle");
	const email = feature.getProperty("email");
	const position = feature.getGeometry().get();
	const content = `
      <div class="infomap_fm">
      <div class="title">${name}</div>
      <div class="addresstitle">${addresstitle}</div>
      ${address}
      <div class="phones">${phones}</div>
      <div class="phones">${email}</div>
      <div class="bottom-meta">
	     
      </div>
      </div>
    `;

	window.groupex.mapData.members.infoWindow.setContent(content);
	window.groupex.mapData.members.infoWindow.setPosition(position);
	window.groupex.mapData.members.infoWindow.setOptions({
		pixelOffset: new google.maps.Size(0, -30),
	});
	window.groupex.mapData.members.infoWindow.open(
		window.groupex.mapData.members,
	);
	window.groupex.mapData.members.map.setZoom(12);
	window.groupex.mapData.members.map.setCenter(
		window.groupex.mapData.members.infoWindow.getPosition(),
	);
}

function mapInfoWindow(feature) {
	const name = feature.getProperty("name");
	const address = feature.getProperty("address");
	const phones = feature.getProperty("phones");
	const website = feature.getProperty("website");
	const addresstitle = feature.getProperty("addresstitle");
	const contact = feature.getProperty("contact");
	const url = feature.getProperty("url");
	const position = feature.getGeometry().get();
	const content = `
      <div class="infomap_fm">
      <div class="title">${name}</div>
      <div class="addresstitle">${addresstitle}</div>
      ${address}
      <div class="phones">${phones}</div>
      <div class="bottom-meta">
  	      <div class="link"><div class="item-fm-meta link">${url}</div></div>
	      <div class="website">${website}</div>
	      <div class="contact">${contact}</div>
      </div>
      </div>
    `;

	window.groupex.mapData.fournisseurs.infoWindow.setContent(content);
	window.groupex.mapData.fournisseurs.infoWindow.setPosition(position);
	window.groupex.mapData.fournisseurs.infoWindow.setOptions({
		pixelOffset: new google.maps.Size(0, -30),
	});
	window.groupex.mapData.fournisseurs.infoWindow.open(
		window.groupex.mapData.fournisseurs,
	);
	window.groupex.mapData.fournisseurs.map.setZoom(12);
	window.groupex.mapData.fournisseurs.map.setCenter(
		window.groupex.mapData.fournisseurs.infoWindow.getPosition(),
	);
}

function getMapDarkStyle() {
	return [
		{
			featureType: "administrative",
			elementType: "all",
			stylers: [
				{
					saturation: "-100",
				},
			],
		},
		{
			featureType: "administrative.province",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "landscape",
			elementType: "all",
			stylers: [
				{
					saturation: -100,
				},
				{
					lightness: 65,
				},
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "poi",
			elementType: "all",
			stylers: [
				{
					saturation: -100,
				},
				{
					lightness: "50",
				},
				{
					visibility: "simplified",
				},
			],
		},
		{
			featureType: "road",
			elementType: "all",
			stylers: [
				{
					saturation: "-100",
				},
			],
		},
		{
			featureType: "road.highway",
			elementType: "all",
			stylers: [
				{
					visibility: "simplified",
				},
			],
		},
		{
			featureType: "road.arterial",
			elementType: "all",
			stylers: [
				{
					lightness: "30",
				},
			],
		},
		{
			featureType: "road.local",
			elementType: "all",
			stylers: [
				{
					lightness: "40",
				},
			],
		},
		{
			featureType: "transit",
			elementType: "all",
			stylers: [
				{
					saturation: -100,
				},
				{
					visibility: "simplified",
				},
			],
		},
		{
			featureType: "water",
			elementType: "geometry",
			stylers: [
				{
					hue: "#ffff00",
				},
				{
					lightness: -25,
				},
				{
					saturation: -97,
				},
			],
		},
		{
			featureType: "water",
			elementType: "labels",
			stylers: [
				{
					lightness: -25,
				},
				{
					saturation: -100,
				},
			],
		},
	];
}

function processPoints(geometry, callback, thisArg) {
	if (geometry instanceof google.maps.LatLng) {
		callback.call(thisArg, geometry);
	} else if (geometry instanceof google.maps.Data.Point) {
		callback.call(thisArg, geometry.get());
	} else {
		geometry.getArray().forEach(function (g) {
			processPoints(g, callback, thisArg);
		});
	}
}

const wrap = (elem, tag, className = "") => {
	const div = document.createElement(tag);
	if (Array.isArray(className)) {
		div.classList.add(...className);
	} else {
		div.classList.add(className);
	}
	elem.parentElement.insertBefore(div, elem);
	div.appendChild(elem);
};

const next = function (elem, selector) {
	if (elem == null) return null;
	// Get the next element
	let nextElem = elem.nextElementSibling;

	// If there's no selector, return the next element
	if (!selector) {
		return nextElem;
	}

	// Otherwise, check if the element matches the selector
	if (nextElem && nextElem.matches(selector)) {
		return nextElem;
	}

	// if it's not a match, return null
	return null;
};

const prev = function (elem, selector) {
	if (elem == null) return null;
	// Get the prev element
	let prevElem = elem.previousElementSibling;

	// If there's no selector, return the prev element
	if (!selector) {
		return prevElem;
	}

	// Otherwise, check if the element matches the selector
	if (prevElem && prevElem.matches(selector)) {
		return prevElem;
	}

	// if it's not a match, return null
	return null;
};

const getSiblings = function (e) {
	// for collecting siblings
	let siblings = [];
	// if no parent, return no sibling
	if (!e.parentNode) {
		return siblings;
	}
	// first child of the parent node
	let sibling = e.parentNode.firstChild;

	// collecting siblings
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== e) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

function video_module_fns() {
	play_buttons_click();

	[...document.querySelectorAll(".video_item")].forEach((element, i) => {
		let boundVideoLaunch = videoLaunch.bind(null, element);
		element.removeEventListener("click", boundVideoLaunch);
		element.addEventListener("click", boundVideoLaunch, false);
	});
}

function play_buttons_click() {
	[...document.querySelectorAll(".video_player .play")].forEach(
		(element, i) => {
			let boundPlay = play_video.bind(null, element);
			element.removeEventListener("click", boundPlay);
			element.addEventListener("click", boundPlay, false);
		},
	);
}

function videoLaunch(el, e) {
	if (!el.classList.contains("active")) {
		let data = el.dataset,
			title = data.title,
			type = data.type,
			video = JSON.parse(data.video),
			videoData = JSON.parse(data.videodata),
			video_player_wrap = el.closest(".videos");
		if (video_player_wrap) {
			let video_player = video_player_wrap.querySelector(".video_player"),
				video_div = video_player.querySelector(".video"),
				video_title_div = video_player.querySelector(".video_title"),
				video_data_div = video_player.querySelector(".video_data");

			video_div.innerHTML = video;
			video_title_div.innerHTML = title;
			video_data_div.innerHTML = videoData;
			play_buttons_click();
			like_buttons_click();

			if (type == "file") {
				video_div.querySelector(".play").click();
			}

			let siblings = getSiblings(el);
			siblings.map((e) => e.classList.remove("active"));

			el.classList.add("active");
			if (Foundation.MediaQuery.current == "small") {
				video_player_wrap.scrollIntoView({
					behavior: "smooth",
					block: "start",
					inline: "nearest",
				});
			}
		}
	}
}

function play_video(el, e) {
	e.preventDefault();
	let video = next(el, "video");
	el.style.display = "none";
	video.play();
	video.setAttribute("controls", "controls");
}

function like_buttons_click() {
	[...document.querySelectorAll(".sl-button")].forEach((element, i) => {
		let boundLikeClick = like_button_click.bind(null, element);
		element.removeEventListener("click", boundLikeClick);
		element.addEventListener("click", boundLikeClick, false);
	});
}

function like_button_click(el, event) {
	event.preventDefault();

	let button = el,
		post_id = button.dataset.postId,
		security = button.dataset.nonce,
		iscomment = button.dataset.iscomment,
		allbuttons = document.querySelector(".sl-button-" + post_id);

	if (post_id !== "") {
		const payload = {
			action: "process_simple_like",
			post_id: post_id,
			nonce: security,
			is_comment: iscomment,
		};

		const data = new FormData();

		Object.keys(payload).forEach((key) => {
			data.append(key, payload[key]);
		});

		allbuttons.classList.add("loading");

		fetch(groupex_vars.ajaxurl, {
			method: "POST",
			credentials: "same-origin",
			body: data,
		})
			.then((response) => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				return response;
			})
			.then((response) => response.json())
			.then((data) => {
				let icon = data.icon,
					count = data.count;

				allbuttons.classList.remove("loading");

				allbuttons.innerHTML = icon + count;

				if (data.status === "unliked") {
					allbuttons.classList.remove("liked");
				} else {
					allbuttons.classList.add("liked");
				}
			})
			.catch((error) => {
				console.error(error);
			});
		return false;
	}
}

function colorscheme_switch() {
	let switchwrap = document.getElementById("colorscheme");

	if (switchwrap) {
		let checkbox = switchwrap.querySelector("input"),
			body = document.querySelector("body");

		checkbox.addEventListener("change", (event) => {
			if (event.currentTarget.checked) {
				body.classList.remove("dark-mode");
				body.classList.add("light-mode");
				Cookies.set("colorscheme", "light", { expires: 365 });
			} else {
				body.classList.remove("light-mode");
				body.classList.add("dark-mode");
				Cookies.set("colorscheme", "dark", { expires: 365 });
			}
		});
	}
}

function facture_calculator() {
	jQuery(document).on("input", ".price_calculate", function () {
		let value = jQuery(this).val(),
			$parent = jQuery(this).closest("tr"),
			$table = $parent.closest("table"),
			qty = $parent.find(".qty_calculate").val(),
			$total = $parent.find(".total_calculate");

		$total.val(qty * value).trigger("change");

		$table.trigger("repeat_change");
	});
	jQuery(document).on("input", ".qty_calculate", function () {
		let value = jQuery(this).val(),
			$parent = jQuery(this).closest("tr"),
			$table = $parent.closest("table"),
			price = $parent.find(".price_calculate").val(),
			$total = $parent.find(".total_calculate");

		$total.val(value * price).trigger("change");

		$table.trigger("repeat_change");
	});
	jQuery(document).on("click", ".custom_repeater_add a", function (event) {
		event.preventDefault();
		let $table = jQuery(this)
				.closest("form")
				.find(".facture_repeat")
				.find(".ff_repeater_table"),
			last_add = $table
				.find("tbody")
				.find("tr:last-child")
				.find(".repeat-plus");

		last_add.click();
		$table.trigger("repeat_change");
	});
}

function learndash_course_grid_init_grid_responsive_design() {
	const wrappers = document.querySelectorAll(
		'.learndash-course-grid[data-skin="g-grid"]',
	);

	wrappers.forEach(function (wrapper) {
		const items_wrapper = wrapper.querySelector(".items-wrapper.g-grid");

		if (!items_wrapper) {
			return;
		}

		const first_item = items_wrapper.firstElementChild;

		if (!first_item) {
			return;
		}

		// Set columns
		const min_width = wrapper.dataset.min_column_width;

		let columns = wrapper.dataset.columns;
		columns = parseInt(columns);
		let new_columns = wrapper.dataset.new_columns || columns;
		new_columns = parseInt(new_columns);

		const wrapper_width = wrapper.offsetWidth;
		let upper_columns = new_columns + 1;
		upper_columns = upper_columns > columns ? columns : upper_columns;
		const min_item_width = wrapper_width / upper_columns;

		new_columns = Math.floor(wrapper_width / min_width);

		let item_width = first_item.offsetWidth;

		if (item_width < min_width) {
			new_columns = new_columns > columns ? columns : new_columns;
			new_columns = new_columns < 1 ? 1 : new_columns;
			wrapper.dataset.new_columns = new_columns;
			items_wrapper.style.gridTemplateColumns =
				"repeat( " + new_columns + ", minmax( 0, 1fr ) )";
		} else if (min_item_width > min_width) {
			new_columns = new_columns > columns ? columns : new_columns;
			new_columns = new_columns < 1 ? 1 : new_columns;
			wrapper.dataset.new_columns = new_columns;
			items_wrapper.style.gridTemplateColumns =
				"repeat( " + new_columns + ", minmax( 0, 1fr ) )";
		}

		const items = items_wrapper.querySelectorAll(".item");
		items.forEach(function (item) {
			// Display item
			item.style.visibility = "visible";
		});
	});
}
function lms_prepare_filter(filter) {
	let data = {};

	if (!filter) {
		return data;
	}

	const search = filter.querySelector('input[name="search"]');
	const price_min = filter.querySelector('[name="price_min"]');
	const price_max = filter.querySelector('[name="price_max"]');

	data.search = search ? search.value : null;

	let taxonomies = filter.dataset.taxonomies;
	taxonomies = taxonomies.split(",").map(function (value) {
		return value.trim();
	});

	data.price_min = price_min ? price_min.value : null;
	data.price_max = price_max ? price_max.value : null;

	taxonomies.forEach(function (taxonomy) {
		const inputs = filter.querySelectorAll(
			'input[name="' + taxonomy + '[]"]:checked',
		);

		let values = [];
		inputs.forEach(function (input) {
			values.push(input.value);
		});

		data[taxonomy] = values;
	});

	return data;
}

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMapWithMarkers($el) {
	// Find marker elements within map.
	var $markers = $el.find(".marker");

	// Create gerenic map.
	var mapArgs = {
		zoom: $el.data("zoom") || 16,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		disableDefaultUI: true,
		zoomControl: true,
		styles: getMapDarkStyle(),
	};
	var map = new google.maps.Map($el[0], mapArgs);

	// Add markers.
	map.markers = [];
	$markers.each(function (i, el) {
		initMarker(jQuery(this), map, i);
	});

	// Center map based on markers.
	centerMap(map);

	// Return map instance.
	return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker($marker, map, i) {
	// Get position from marker.
	var lat = $marker.data("lat");
	var lng = $marker.data("lng");
	var latLng = {
		lat: parseFloat(lat),
		lng: parseFloat(lng),
	};

	// Create marker instance.
	var marker = new google.maps.Marker({
		position: latLng,
		map: map,
		icon: {
			url: groupex_vars.media.mapIcon,
			scaledSize: new google.maps.Size(32, 32),
		},
	});

	// Append to reference for later use.
	map.markers.push(marker);

	// If marker contains HTML, add it to an infoWindow.
	if ($marker.html()) {
		// Create info window.
		var infowindow = new google.maps.InfoWindow({
			content: $marker.html(),
		});

		// Show info window when marker is clicked.
		google.maps.event.addListener(marker, "click", function () {
			infowindow.open(map, marker);
		});
		if (i == 0) {
			infowindow.open(map, marker);
		}
	}
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap(map) {
	// Create map boundaries from all map markers.
	var bounds = new google.maps.LatLngBounds();
	map.markers.forEach(function (marker) {
		bounds.extend({
			lat: marker.position.lat(),
			lng: marker.position.lng(),
		});
	});

	// Case: Single marker.
	if (map.markers.length == 1) {
		map.setCenter(bounds.getCenter());

		// Case: Multiple markers.
	} else {
		map.fitBounds(bounds);
	}
}

function wdmChkPwdStrength(
	$pwd,
	$confirmPwd,
	$strengthStatus,
	$submitBtn,
	blacklistedWords,
) {
	var pwd = $pwd.val();
	var confirmPwd = $confirmPwd.val();

	// extend the blacklisted words array with those from the site data
	blacklistedWords = blacklistedWords.concat(
		wp.passwordStrength.userInputDisallowedList(),
	);

	// $submitBtn.attr("disabled", "disabled");
	$strengthStatus.removeClass("short bad good strong");

	// calculate the password strength
	var pwdStrength = wp.passwordStrength.meter(
		pwd,
		blacklistedWords,
		confirmPwd,
	);

	// check the password strength
	switch (pwdStrength) {
		case 2:
			$strengthStatus.addClass("bad").html(pwsL10n.bad);
			break;

		case 3:
			$strengthStatus.addClass("good").html(pwsL10n.good);
			break;

		case 4:
			$strengthStatus.addClass("strong").html(pwsL10n.strong);
			break;

		case 5:
			$strengthStatus.addClass("bad").html(pwsL10n.mismatch);
			break;

		default:
			$strengthStatus.addClass("bad").html(pwsL10n.short);
	}

	return pwdStrength;
}

function run_password_meter() {
	let is_password_edit = document.querySelector(
		'input[name="is_password_edit"]',
	);
	if (is_password_edit) {
		if (is_password_edit.value == "yes") {
			let password_field = document.querySelector(
				'.fluentform input[type="password"][name="password"]',
			);
			password_field.insertAdjacentHTML(
				"afterend",
				'<span id="password-strength"></span>',
			);

			$("body").on(
				"keyup",
				'.fluentform input[name="password"], .fluentform input[name="password1"]',
				function (event) {
					wdmChkPwdStrength(
						// password field
						$('.fluentform input[name="password"]'),
						// confirm password field
						$('.fluentform input[name="password1"]'),
						// strength status
						$("#password-strength"),
						// Submit button
						$(".fluentform input[type=submit]"),
						// blacklisted words which should not be a part of the password
						["admin", "happy", "hello", "12345678"],
					);
				},
			);
		}
	}
}

function groupex_popup() {
	let gpopup_id = "#popupgroupex",
		gpopup = document.querySelector(gpopup_id);

	if (gpopup) {
		let gpopup_link_type = gpopup.dataset.link,
			gpopup_survey_id = gpopup.dataset.survey,
			cvalue = Cookies.get("groupex_popup");

		if (cvalue) {
			if (gpopup_link_type == "survey") {
				if (!Cookies.get("survey_" + gpopup_survey_id)) {
					jQuery(gpopup_id).foundation("open");
				}
			}
		} else {
			jQuery(gpopup_id).foundation("open");
		}

		jQuery(gpopup_id).on("closed.zf.reveal", function (event) {
			Cookies.set("groupex_popup", gpopup_link_type);
		});
	}
}
